export enum UpsellOfferOrigin {
  MEIN_PLUS = 'MEIN_PLUS',
  RENT_PROFILE = 'RENT_PROFILE',
  TENANT_VIEW = 'TENANT_VIEW',
}

export enum OfferType {
  MIETER_PLUS = 'MIETER_PLUS',
  WOHNEN_PLUS = 'WOHNEN_PLUS',
}

export interface UpsellOfferResponse {
  // Add response fields based on your needs
  isEligible: boolean;
  showOffer: boolean;
  showCount: number;
}
